import { formatReportDateUnix, stripMarkdown } from "@entities/history";
import { FixedAccordion } from "@shared/ui/fixed-accordion";
import { ReportServicesProps } from "./types";
import classes from "./report-services.module.scss";

export const ReportServices = ({ events, isPdfMode = false }: ReportServicesProps) => {
    const serviceEvents = events.filter((e) => e.type === "to");

    return (
        <div className={classes.services}>
            {serviceEvents.length === 0 ? (
                <div className={classes.services__empty}>Нет записей о посещении автосервисов</div>
            ) : (
                serviceEvents.map((event, index) => (
                    <FixedAccordion
                        key={index}
                        expanded={isPdfMode}
                        title={
                            <div className={classes.services__title}>
                                {formatReportDateUnix(event.date)}
                                <span className={classes.services__info}>
                                    {event.source}, {event.mileage} км
                                </span>
                            </div>
                        }
                        content={
                            <div className={classes.services__content}>
                                {event.description
                                    ? stripMarkdown(event.description)
                                    : "Описание отсутствует"}
                            </div>
                        }
                    />
                ))
            )}
        </div>
    );
};